import { useQueryClient } from '@tanstack/react-query'

import { useAppMutation } from '@/helpers/api/mutation'
import { createInstance } from '@/helpers/api/base'
import { useGetUserInfo } from '@/modules/Auth'
import { useModal } from '@/components/Modal'
import { useNotification } from '@/ui/Notification'
import { Log, LogUnfinishedMetadata } from '@/types/logs'
import { GET_FLAGGED_LOGS_KEY } from '@/pages/UnfinishedRecords/api/useGetFlaggedLogs'
import FlagIcon from '@/modules/CombinedLogs/assets/flag.svg'

export const useFlagRecordDone = () => {
    const queryClient = useQueryClient()
    const { data: userInfo } = useGetUserInfo()
    const { closeModal } = useModal()
    const { showNotification } = useNotification()

    const { mutate, isPending } = useAppMutation<LogUnfinishedMetadata, Error, string>({
        mutationFn: (logId) =>
            createInstance({
                url: `/controller-logs/${logId}/flag-done`,
                method: 'PATCH',
                data: {
                    author: userInfo?.lastSessionDetails.authorName ?? '',
                },
            }),
        alertOnError: true,
        onSuccess: (data, logId) => {
            const updater = (prev: Log[] | undefined) =>
                prev?.map((log) => (log.id === logId ? { ...log, unfinishedFlagMetadata: data } : log))
            queryClient.setQueriesData<Log[]>({ queryKey: [GET_FLAGGED_LOGS_KEY] }, updater)
            queryClient.setQueriesData<Log[]>({ queryKey: ['controllerLogs'] }, updater)
            closeModal()
            showNotification({
                type: 'submit',
                size: 'small',
                message: 'Marked as done',
                icon: <span style={{ color: 'var(--icon-highlight-secondary)' }}><FlagIcon /></span>,
            })
        },
    })

    return { mutate, isPending }
}
